<span class="apill" [style.color]="resolvedColor()" [style.background]="bg()">{{ resolvedLabel() }}</span>
